import { render } from "./AppointmentEditModal.vue?vue&type=template&id=631dc808&scoped=true"
import script from "./AppointmentEditModal.vue?vue&type=script&lang=js"
export * from "./AppointmentEditModal.vue?vue&type=script&lang=js"

import "./AppointmentEditModal.vue?vue&type=style&index=0&id=631dc808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631dc808"]])

export default __exports__